(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cf-swatch]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    handleSwatchClick(btn);
  });

  function handleSwatchClick(btn) {
    var card = btn.closest('.cf-card');
    if (!card) return;
    var colorId = btn.dataset.colorId;

    updateActiveState(card, btn);
    updateImages(card, colorId);
    updateUrls(card, btn.dataset.productUrl);
    updateAtcButton(card, btn);
    // DATORACODE - Badges werden server-seitig via product-badges-Resolver gerendert (kein Swatch-Update, kein Überschreiben)
    updatePriceDisplay(card, btn);
    updateDatora(card, btn);
    checkSwatchOverflow(card);
  }

  function updateActiveState(card, btn) {
    card.querySelectorAll('[data-cf-swatch]').forEach(function (s) {
      s.classList.toggle('cf-card__swatch--active', s === btn);
    });
  }

  function updateImages(card, colorId) {
    card.querySelectorAll('img[data-color-id]').forEach(function (img) {
      if (img.dataset.colorId === colorId) {
        img.removeAttribute('hidden');
      } else {
        img.setAttribute('hidden', '');
      }
    });
  }

  function updateUrls(card, url) {
    card.querySelectorAll('[data-card-link]').forEach(function (el) {
      el.href = url;
    });
  }

  function updateAtcButton(card, btn) {
    var atc = card.querySelector('[data-atc-modal-trigger]');
    if (!atc) return;
    atc.dataset.productUrl = btn.dataset.productUrl;
    atc.dataset.variantId = btn.dataset.variantId;
  }

  function updatePriceDisplay(card, btn) {
    var priceDiv = card.querySelector('.price');
    if (!priceDiv) return;

    var price = parseInt(btn.dataset.price, 10);
    var compare = parseInt(btn.dataset.compareAtPrice, 10);
    // DATORACODE - isOnSale an hide_compare_prices koppeln; A/B-Test (CFSN-620): B/C erzwingen die Sale-Darstellung
    var abPriceVariantActive =
      priceDiv.classList.contains('price--v620-inline') || priceDiv.classList.contains('price--v620-twoline');
    var isOnSale = (abPriceVariantActive || !window.themeSettings.hideComparePrices) && compare > price;

    var formattedPrice = typeof formatPrice === 'function'
      ? formatPrice(price) : '';
    var formattedCompare = isOnSale && typeof formatPrice === 'function'
      ? formatPrice(compare) : '';

    var regularItem = priceDiv.querySelector('.price__regular .price-item--regular');
    if (regularItem && typeof setPriceText === 'function') setPriceText(regularItem, formattedPrice);

    var saleItem = priceDiv.querySelector('.price__sale .price-item--sale');
    if (saleItem && typeof setPriceText === 'function') setPriceText(saleItem, formattedPrice);

    var compareItem = priceDiv.querySelector('.price__sale s.price-item--regular');
    if (compareItem && typeof setPriceText === 'function') setPriceText(compareItem, formattedCompare);

    priceDiv.classList.toggle('price--on-sale', isOnSale);

    // DATORACODE - A/B-Test (CFSN-620): Sale-Prozent-Attribut und Liquid-Sale-Badge beim Swatch-Wechsel
    // nachziehen (0% => Badge per Klasse versteckt); datora.js liest beides nach dem Reset erneut
    if (abPriceVariantActive) {
      // DATORACODE - A/B-Test (CFSN-620): gleiche Operationsreihenfolge wie Liquid ((C-P)*100/C), sonst 1%-Drift an .5-Grenzen
      var salePct = compare > price ? Math.round(((compare - price) * 100) / compare) : 0;
      priceDiv.dataset.datoraSalePct = String(salePct);
      var saleBadge = priceDiv.querySelector('.price__badge-sale');
      if (saleBadge) {
        saleBadge.innerHTML = '<b>-' + salePct + '%</b>';
        saleBadge.classList.toggle('price__badge-sale--hidden', salePct < 1);
      }
    }
  }

  function updateDatora(card, btn) {
    var priceDiv = card.querySelector('[data-datora-product-id]');
    if (!priceDiv) return;

    priceDiv.dataset.datoraVariantId = btn.dataset.variantId;
    priceDiv.dataset.datoraPrice = btn.dataset.price;
    priceDiv.dataset.datoraSalePrice = btn.dataset.salePrice;
    priceDiv.dataset.datoraCompare = btn.dataset.compareAtPrice;
    priceDiv.dataset.datoraPriceVaries = 'false';

    if (typeof resetProductGridDiscount === 'function') {
      resetProductGridDiscount(priceDiv);
    }
    if (typeof co2 !== 'undefined' && typeof updateProductGridDiscounts === 'function') {
      updateProductGridDiscounts(card);
    }
  }

  /* --- Swatch overflow --- */

  function checkSwatchOverflow(card) {
    var container = card.querySelector('.cf-card__swatches');
    if (!container) return;

    var swatches = Array.from(container.querySelectorAll('[data-cf-swatch]'));
    var moreLink = container.querySelector('.cf-card__more');
    if (swatches.length === 0) return;

    var baseOverflow = parseInt(container.dataset.baseOverflow, 10) || 0;

    function updateMoreLink(count) {
      if (!moreLink) return;
      if (count > 0) {
        moreLink.removeAttribute('hidden');
        moreLink.textContent = '+' + count;
        var ariaTemplate = moreLink.dataset.ariaTemplate || '';
        moreLink.setAttribute('aria-label', ariaTemplate.replace('__COUNT__', count));
      } else {
        moreLink.setAttribute('hidden', '');
      }
    }

    // Restore original DOM order (by data-swatch-index)
    swatches
      .sort(function (a, b) { return (parseInt(a.dataset.swatchIndex, 10) || 0) - (parseInt(b.dataset.swatchIndex, 10) || 0); })
      .forEach(function (s) { container.insertBefore(s, moreLink); });

    // Show all swatches, hide "+X" to measure without it
    swatches.forEach(function (s) { s.removeAttribute('hidden'); });
    updateMoreLink(0);

    // Case 1: all DOM swatches fit AND no Liquid overflow → done
    if (container.scrollWidth <= container.clientWidth && baseOverflow === 0) {
      return;
    }

    // Case 2: all DOM swatches fit BUT Liquid has overflow → show "+X" with base count
    if (container.scrollWidth <= container.clientWidth && baseOverflow > 0) {
      updateMoreLink(baseOverflow);
      if (container.scrollWidth <= container.clientWidth) {
        return; // fits with "+X"
      }
      // "+X" caused overflow → fall through to hide loop
    }

    // Confirmed overflow — ensure "+X" visible for measurement
    if (moreLink) moreLink.removeAttribute('hidden');

    // Hide swatches from end (skip active) until fits
    var hidden = 0;
    for (var i = swatches.length - 1; i >= 0; i--) {
      if (container.scrollWidth <= container.clientWidth) break;
      if (swatches[i].classList.contains('cf-card__swatch--active')) continue;
      swatches[i].setAttribute('hidden', '');
      hidden++;
    }

    // If active swatch is visually beyond overflow, move it to front and re-hide
    var activeSwatch = container.querySelector('.cf-card__swatch--active');
    if (activeSwatch) {
      var containerRight = container.getBoundingClientRect().right;
      var activeRight = activeSwatch.getBoundingClientRect().right;
      if (activeRight > containerRight) {
        container.insertBefore(activeSwatch, container.querySelector('[data-cf-swatch]'));
        // Re-hide from visible tail until fits
        var visible = container.querySelectorAll('[data-cf-swatch]:not([hidden])');
        for (var j = visible.length - 1; j >= 0; j--) {
          if (container.scrollWidth <= container.clientWidth) break;
          if (visible[j].classList.contains('cf-card__swatch--active')) continue;
          visible[j].setAttribute('hidden', '');
          hidden++;
        }
      }
    }

    // Final "+X" with total hidden count (Liquid base + JS hidden)
    updateMoreLink(baseOverflow + hidden);
  }

  function checkAllCards() {
    document.querySelectorAll('.cf-card').forEach(checkSwatchOverflow);
  }

  // Debounce helper
  var resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(checkAllCards, 150);
  }

  // Init — DOMContentLoaded may have already fired (defer script)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkAllCards);
  } else {
    checkAllCards();
  }
  window.addEventListener('resize', onResize);

  // Global hook for re-init (e.g. after related products lazy load)
  window.cfCardOverflowInit = checkAllCards;

})();
